const createUnitTitle = (name: string, accomomdationName: string | undefined, accommodationPageIsPublic: boolean) =>
    accommodationPageIsPublic ? `${accomomdationName}` : `${name}`;

export default createUnitTitle;
